import { render, staticRenderFns } from "./shareCouponManage.vue?vue&type=template&id=5b0d12b0&scoped=true"
import script from "./shareCouponManage.vue?vue&type=script&lang=js"
export * from "./shareCouponManage.vue?vue&type=script&lang=js"
import style0 from "./shareCouponManage.vue?vue&type=style&index=0&id=5b0d12b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d12b0",
  null
  
)

export default component.exports